import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FocusNextInputDirective} from './focus-next-input.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FocusNextInputDirective],
  exports: [FocusNextInputDirective]
})
export class DirectivesModule {}
